import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-workflow-step-app-assets',
  templateUrl: './workflow-step-app-assets.component.html',
  styleUrls: ['./workflow-step-app-assets.component.css']
})
export class WorkflowStepAppAssetsComponent implements OnInit {

  isLinear = true;

  constructor() { }

  ngOnInit() {
  }

}
